import { apiBaseUrl } from 'APIs';
import { AxiosRequestConfig } from 'axios';
import { axios } from './interceptors/request.interceptor';

import { ACCESS_TOKEN } from 'constant';
import BackstageComment from 'interfaces/BackstageComment.interface';

export enum CommentType {
  BACKSTAGE = 1,
  NFT = 0,
  OTR = 2,
}

export interface BackstageCommenDto {
  postId: string;
  content: string;
  parentId?: string;
  type: CommentType;
}

export const getAllBackstageComment = async () => {
  const url = `${apiBaseUrl}backstage/comment/`;
  const res = await axios.get<BackstageComment[]>(url);
  if (res.status === 200) {
    return res.data;
  }
};

export const postBackstageComment = async (data: BackstageCommenDto) => {
  const config: AxiosRequestConfig<any> = {
    headers: {
      Authorization: `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
    },
  };
  const url = `${apiBaseUrl}backstage/comment/`;
  const res = await axios.post(url, data, config);
  if (res.status === 201) {
    return res.data;
  }
};

// export const patchBackstageComment = async (id: string, data: Partial<BackstageComment>) => {
//   const config: AxiosRequestConfig<any> = {
//     headers: {
//       Authorization: `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
//     },
//   }
//   const url = `${apiBaseUrl}backstage/comment/${id}`;
//   const res = await axios.patch<{id: number}>(url, data, config);
//   if (res.status === 202) {
//     return res.data
//   }
// };

// export const deleteBackstageComment = async (id: string) => {
//   const config: AxiosRequestConfig<any> = {
//     headers: {
//       Authorization: `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
//     },
//   }
//   const url = `${apiBaseUrl}backstage/comment/${id}`;
//   const res = await axios.delete<{id: number}>(url, config);
//   if (res.status === 202) {
//     return res.data
//   }
// };
